export const taskStatus = [
  { value: "NEW", label: "New" },
  { value: "SELECTED_SOURCE", label: "Selected Source" },
  { value: "INPROGRESS", label: "In Progress" },
  { value: "POST_PROCESS", label: "Post Process" },
  { value: "COMPLETE", label: "Complete" },
  { value: "FAILED", label: "Failed" },
  { value: "REOPEN", label: "Reopen" },
  { value: "PARAPHRASE", label: "Paraphrase" },
];

export const taskTypes = [
  { value: "TRANSCRIPTION_EDIT", label: "Transcription Edit" },
  { value: "TRANSCRIPTION_REVIEW", label: "Transcription Review" },
  { value: "TRANSLATION_EDIT", label: "Translation Edit" },
  { value: "TRANSLATION_REVIEW", label: "Translation Review" },
  { value: "VOICEOVER_EDIT", label: "VoiceOver Edit" },
  { value: "TRANSLATION_VOICEOVER_EDIT", label: "Translation VoiceOver Edit" },
  { value: "TRANSLATION_VOICEOVER_REVIEW", label: "Translation VoiceOver Review" },
];
